import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetStatsQuery } from "services/partners/api";

import PendingPartnersTab from "./PendingPartnersTab";
import ApprovedPartnersTab from "./ApprovedPartnersTab";
import SuspendedPartnersTab from "./SuspendedPartnersTab";
import RejectedPartnersTab from "./RejectedPartnersTab";

import { Tab, TabGroup, TabList, TabPanels, TabPanel } from "@headlessui/react";

const Partners = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  //meta title
  document.title = `${props.t("Partners")} | ${process.env.REACT_APP_CMS_TITLE}`;

  const [selectedIndex, setSelectedIndex] = useState(0);
  const { data: stats, isLoading } = useGetStatsQuery();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get("tab");
    if (tabParam === "approved") {
      setSelectedIndex(1);
    } else if (tabParam === "suspended") {
      setSelectedIndex(2);
    } else if (tabParam === "rejected") {
      setSelectedIndex(3);
    } else {
      setSelectedIndex(0);
    }
  }, [location.search]);

  const handleTabChange = (index) => {
    setSelectedIndex(index);
    let tabValue = "pending";
    if (index === 1) tabValue = "approved";
    else if (index === 2) tabValue = "suspended";
    else if (index === 3) tabValue = "rejected";

    navigate(`/partners?tab=${tabValue}`);
  };

  return (
    <div className="page-content" data-testid="partners-page">
      <Container fluid>
        <Breadcrumbs title={props.t("Partners")} breadcrumbItem={props.t("Partners")} />
        {/* Add your partners management content here */}
        <div className="d-flex flex-column gap-4">
          <TabGroup selectedIndex={selectedIndex} onChange={handleTabChange}>
            <TabList>
              <Tab data-testid="new-tab">
                พาร์ทเนอร์ใหม่รออนุมัติ
                {stats?.pending > 0 && <span className="badge-noti">{stats.pending}</span>}
              </Tab>
              <Tab data-testid="system-tab">พาร์ทเนอร์ในระบบ</Tab>
              <Tab data-testid="ban-tab">พาร์ทเนอร์ที่ถูกแบน</Tab>
              <Tab data-testid="hide-tab">
                พาร์ทเนอร์ที่ถูกซ่อน
                {/* {stats?.rejected > 0 && <span className="badge-noti">{stats.rejected}</span>} */}
              </Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <PendingPartnersTab />
              </TabPanel>
              <TabPanel>
                <ApprovedPartnersTab />
              </TabPanel>
              <TabPanel>
                <SuspendedPartnersTab />
              </TabPanel>
              <TabPanel>
                <RejectedPartnersTab />
              </TabPanel>
            </TabPanels>
          </TabGroup>
        </div>
      </Container>
    </div>
  );
};

export default withTranslation()(Partners);
